<template>
     <vs-dialog v-model="active">
        <template #header>
          <h4 class="not-margin">
            Cancelar beca
          </h4>
        </template>


        <div class="con-form">
          <vs-row>
            <vs-col vs-justify="center" vs-align="center" w="12">
              <center> 
                <h6>¿Seguro que deseas cancelar la beca?</h6>
              </center>
            </vs-col>
          </vs-row>
        </div>
        <template #footer>
          <div class="footer-dialog" style="display:flex;">  
            <vs-button block danger class="color-red" @click="close">
              Cancelar
            </vs-button>
            <vs-button block success @click="cancelarCargo">
              Aceptar
            </vs-button>          
          </div>
        </template>
      </vs-dialog>
</template>

<script>
import cobranza from '../../../../../api/requests/cobranza-persona.js'
export default {
    props:[
      'value',
      'rows',
      'personaId',
      'cicloEscolar',
      'institucion',
      'nivel',
      'nivelId',
      'listNivel',
      'programa',
      'programaId',
      'listPrograma',
      'permisos'
    ],
    data () {
        return {
            active: false,
        }
    },
    methods: {
      async cancelarCargo () {
        const loading = this.$vs.loading()
        let formData = new FormData();
        formData.append("id", this.personaId),
        formData.append("id_beca", this.rows.id),
        formData.append("ciclo_escolar", this.cicloEscolar),
        formData.append("institucion", this.institucion),
        formData.append("tipo", 'desaplicar-becas')
        formData.append("programa", this.programa)
        formData.append("nivel_academico", this.nivel)
        const vm = this
            try {
                const response = await cobranza.getInfoAccionButton(formData)
                if(response.data.response[0].status === 200){
                    this.$vs.notification({
                        progress: 'auto',
                        color: 'success',
                        position: null,
                        title: 'Operación éxitosa'
                    })
                    loading.close()
                    this.getPagosCargos()
                }else {
                    if (response.data && response.data.response[0] && response.data.response[0].message){
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: response.data.response[0].message
                        })
                    }
                    loading.close()
                    this.getPagosCargos()
                }

            } catch (error) {
                if (error.response.data && error.response.data.errores){
                    const data = error.response.data.errores
                    if (data.descripcion){
                        this.$vs.notification({
                            progress: 'auto',
                            color: 'danger',
                            position: null,
                            title: 'Error',
                            text: data.descripcion
                        })
                    }
                }else{
                    this.$vs.notification({
                    progress: 'auto',
                    color: 'danger',
                    position: null,
                    title: 'Error',
                    text: `Algo salió mal`
                    })
                }
                loading.close()
            }
      },
      async close () {
        this.active = false
      }
    },
    watch: {
        value (val) {
            this.active = val
        },
        active (val) {
            if (!val){
                this.$emit('input', val);
            }
        }
    }
}
</script>

<style lang="scss"  scoped >
.color-blue {
  background-color: #005aa3;
}
</style>